import * as React from "react"
import IconSkeleton from "./IconSkeleton"
import { IconProps } from "./types"

export default function GeneralIcon(props: IconProps) {
  return (
    <IconSkeleton {...props} stroke="none" iconName="GeneralIcon">
      <path
        d="M22.6607 9.27801C20.4579 10.703 19 13.1812 19 16C19 17.3216 19.3205 18.5684 19.888 19.6668C20.4176 19.122 20.8913 18.5226 21.2997 17.8777C21.1053 17.287 21 16.6558 21 16C21 14.2276 21.7685 12.6348 22.9905 11.5364C22.9583 10.7601 22.8456 10.0046 22.6607 9.27801Z"
        fill="currentColor"
      />
      <path
        d="M16.602 21.994C15.5831 20.2303 15 18.1833 15 16C15 11.5725 17.3978 7.70503 20.9657 5.62533C21.3515 6.16694 21.6894 6.745 21.9733 7.35333C18.9991 9.08615 17 12.3096 17 16C17 17.819 17.4857 19.5246 18.3345 20.9941C17.7912 21.3775 17.2117 21.7128 16.602 21.994Z"
        fill="currentColor"
      />
      <path
        d="M3.39698 5.14461C4.47981 5.69176 5.70393 5.99999 7.00005 5.99999C10.2635 5.99999 13.0705 4.04592 14.315 1.24401C13.6302 1.09734 12.9219 1.01441 12.1964 1.00171C11.1587 2.79417 9.22019 3.99999 7.00005 3.99999C6.25376 3.99999 5.53929 3.86374 4.88016 3.61476C4.33797 4.07559 3.84103 4.58807 3.39698 5.14461Z"
        fill="currentColor"
      />
      <path
        d="M18.0084 2.78435C16.1602 7.03088 11.9269 9.99999 7.00005 9.99999C5.02241 9.99999 3.15651 9.5216 1.51176 8.67422C1.7159 8.02985 1.97778 7.41116 2.29133 6.82424C3.69453 7.57457 5.29761 7.99999 7.00005 7.99999C11.1606 7.99999 14.7277 5.45915 16.2343 1.8445C16.8567 2.1043 17.4501 2.41965 18.0084 2.78435Z"
        fill="currentColor"
      />
      <path
        d="M9.91093 22.8019C9.33274 18.9519 6.01113 16 2.00005 16C1.91687 16 1.83398 16.0013 1.75141 16.0038C2.03454 16.728 2.39221 17.4148 2.81499 18.0549C5.11332 18.367 6.99803 19.9805 7.70253 22.1289C8.40431 22.427 9.14343 22.6543 9.91093 22.8019Z"
        fill="currentColor"
      />
      <path
        d="M1.00012 12.0411C1.32983 12.0139 1.66332 12 2.00005 12C8.23232 12 13.3549 16.751 13.9436 22.8288C13.3127 22.9413 12.6633 23 12 23C11.9836 23 11.9671 23 11.9507 22.9999C11.4489 17.9466 7.18536 14 2.00005 14C1.72648 14 1.45547 14.011 1.18745 14.0325C1.06682 13.3868 1.00261 12.7212 1.00012 12.0411Z"
        fill="currentColor"
      />
    </IconSkeleton>
  )
}
